import type { Theme } from 'Types';
import babas from './babas';
import eggs from './eggs';
import ohpoke from './ohpoke';
import vigarda from './vigarda';
import bores from './bores';
import eighteen from './1889';
import baemingo from './baemingo';
import vmalmo from './vmalmo';
import scaniarinken from './scaniarinken';
import koffein from './koffein';
import pixie from './pixie';
import alvikstrand from './alvikstrand';
import manu from './manu';
import pomflora from './pomflora';
import yuc from './yuc';
import thon from './thon';
import salar from './salar';
import vgbg from './vgbg';
import gronastugan from './gronastugan';
import crowdedhouse from './crowdedhouse';
import gardenkafe from './gardenkafe';
import vbarcelona from './vbarcelona';
import vapiano from './vapiano';
import brogyllen from './brogyllen';
import ubsushi from './ubsushi';
import andysburgers from './andysburgers';
import fattonys from './fattonys';
import mos from './mos';
import ilovepizza from './ilovepizza';
import saigon from './saigon';
import wrapsody from './wrapsody';
import reload from './reload';
import jos from './jos';
import togogo from './togogo';
import portavia from './portavia';
import maha from './maha';
import mittcafe from './mittcafe';
import darkedition from './darkedition';
import nycburger from './nycburger';
import vide from './vide';
import basilica from './basilica';
import fourcorners from './fourcorners';
import dumplingx from './dumplingx';
import dagmars from './dagmars';
import rosegarden from './rosegarden';
import olknacke from './olknacke';

const companies: { [key: string]: Theme } = {
  babas,
  eggs,
  ohpoke,
  vigarda,
  bores,
  1889: eighteen,
  baemingo,
  vmalmo,
  scaniarinken,
  koffein,
  pixie,
  alvikstrand,
  manu,
  pomflora,
  yuc,
  thon,
  salar,
  vgbg,
  gronastugan,
  crowdedhouse,
  gardenkafe,
  vbarcelona,
  vapiano,
  brogyllen,
  ubsushi,
  andysburgers,
  fattonys,
  mos,
  ilovepizza,
  saigon,
  wrapsody,
  reload,
  jos,
  togogo,
  portavia,
  maha,
  mittcafe,
  darkedition,
  nycburger,
  vide,
  basilica,
  fourcorners,
  dumplingx,
  dagmars,
  rosegarden,
  olknacke,
};

export default companies;
